import { useMemo } from "react";
import { Controller, useWatch, type Control } from "react-hook-form";

import type { ICampaignWizardForm } from "../../../../../../../../../../shared/types/form.type";
import { CompactSelect } from "../../../../../../../../../../shared/components/selects/compact-select/CompactSelect";
import { campaignStatusSelectItems } from "../../data/hard-lists";

// Відображення статусу в CompactSelect («none», як раніше)
export const CompactSelectCampaignStatus = (props: {
	control: Control<ICampaignWizardForm>;
}) => {
	const status = useWatch({
		control: props.control,
		name: "campaign_context.campaign.status",
	});
	const value = useMemo(() => {
		const raw = status ?? "";
		const low = raw.toLowerCase();
		if (low === "enabled" || low === "paused") return low;
		return "none";
	}, [status]);

	return (
		<Controller
			control={props.control}
			name='campaign_context.campaign.status'
			render={({ field }) => (
				<CompactSelect
					items={campaignStatusSelectItems}
					value={value}
					onSelect={(key) => field.onChange(key)}
					className={"field-item__select"}
					usePortal
				/>
			)}
		/>
	);
};
